import axios from "axios";

const API_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${API_URL}/api`,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("padel_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => {
    // Auto-emit "stats changed" after any successful mutating request so
    // subscribed pages (Dashboard, PlayerProfile, Marcadores, BestPairs)
    // re-fetch their data without needing a page reload.
    try {
      const method = (response?.config?.method || "get").toLowerCase();
      if (method !== "get" && response?.status >= 200 && response?.status < 300) {
        const url = response?.config?.url || "";
        // Ignore endpoints that only concern the local UI (avatar renders,
        // language / currency preferences etc) — those don't affect stats.
        const isNoise = /\/(auth\/refresh|geo\/lang|users\/me\/(language|currency))/.test(url);
        if (!isNoise) {
          window.dispatchEvent(
            new CustomEvent("dyd:stats-changed", {
              detail: { reason: `axios:${method}`, url, ts: Date.now() },
            })
          );
        }
      }
    } catch (_) { /* no-op */ }
    return response;
  },
  (error) => {
    if (error.response?.status === 401 || error.response?.status === 403) {
      const detail = error.response?.data?.detail || "";
      const isDeactivated = typeof detail === "string" && detail.toLowerCase().includes("desactivada");
      if (error.response.status === 401 || isDeactivated) {
        localStorage.removeItem("padel_token");
        if (window.location.pathname.startsWith("/dashboard")) {
          window.location.href = "/login";
        }
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Algo salio mal. Intenta de nuevo.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e?.msg ? e.msg : JSON.stringify(e))).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}

export default api;
